var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#31B48C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7529 19.767H28.1129C27.7489 18.255 26.9369 17.415 25.1729 17.415C22.6249 17.415 21.4489 19.319 21.3929 24.023C22.3169 22.483 24.1649 21.643 26.1529 21.643C29.7929 21.643 32.3409 24.051 32.3409 28.307C32.3409 32.255 29.9049 35.139 25.5369 35.139C19.4889 35.139 17.9769 30.883 17.9769 24.555C17.9769 17.891 20.1329 14.195 25.3129 14.195C29.4849 14.195 31.4449 16.883 31.7529 19.767ZM25.2569 24.863C23.4369 24.863 21.7569 25.927 21.7569 28.251C21.7569 30.435 23.0449 31.807 25.3409 31.807C27.3569 31.807 28.6169 30.491 28.6169 28.391C28.6169 26.291 27.5249 24.863 25.2569 24.863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.3ca89ba33b619ccd6d1c9b09a7c8b7f7.svg";
export { ForwardRef as ReactComponent };